import { atom } from "jotai";
import type { T_FrontendEnv } from "../env/env";

const foreverPromiseAtom = <T>() =>
  atom<T | Promise<T>>(new Promise<T>(() => {}));

export const ATOM_frontendEnv = foreverPromiseAtom<T_FrontendEnv>();
export const ATOM_frontendEnv_Sync = atom<T_FrontendEnv | null>(null);

ATOM_frontendEnv.debugLabel = "ATOM_frontendEnv";
